var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review"},[_c('div',{staticClass:"review__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"review__body",class:[_vm.classBody]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }